import api from "~/store/api"

export const setSeo = (typeData, data) => {
  const { type_id, type } = typeData
  return api.post(`/seo/${type}/${type_id}`, data).then((res) => res.data.data)
}
